import { LoadableAfterPaint } from '@confluence/loadable';

export const ContentByLabelMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentByLabelMacro" */ '../src/ContentByLabelMacroRenderer.tsx'
			)
		).ContentByLabelMacroRenderer,
});
